import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { NotificationRef, NotificationType } from '@app/dialog/models';
import { Subscription, timer } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('notification', [
            state('void', style({ transform: 'translateY(-100%)', opacity: 0, display: 'block' })),
            state('*', style({ transform: 'translateY(0%)', opacity: 1, display: 'block' })),
            transition('* <=> *', [animate('300ms cubic-bezier(0.55, 0.30, 0.15, 0.90)')]),
        ]),
    ],
    standalone: true,
    imports: [NgClass, TranslateModule],
})
export class NotificationComponent implements OnInit {
  @HostBinding('@notification')
  public notification = true;

  public message: string;
  public typeCSSClass: string;
  public pictogram: string;
  private timer: Subscription = Subscription.EMPTY;

  constructor(private ref: NotificationRef) {
    this.message = this.ref.message;

    switch (this.ref.type) {
      case NotificationType.INFO:
        this.typeCSSClass = 'is-info';
        this.pictogram = 'itvf-add';
        break;
      case NotificationType.SUCCESS:
        this.typeCSSClass = 'is-success';
        this.pictogram = 'itvf-check';
        break;
      case NotificationType.ERROR:
        this.typeCSSClass = 'is-error';
        this.pictogram = 'itvf-close';
        break;

      default:
        this.typeCSSClass = 'is-info';
        this.pictogram = 'itvf-close';
    }
  }

  ngOnInit(): void {
    if (this.ref.duration) {
      this.timer = timer(this.ref.duration).subscribe(() => this.close());
    }
  }

  public close(): void {
    this.ref.close();

    if (this.timer) {
      this.timer.unsubscribe();
    }
  }
}
